import { CollectionViewer, DataSource } from "@angular/cdk/collections";
import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject, of, throwError } from "rxjs";
import { catchError, finalize } from "rxjs/operators";
import { RichiesteDgpeService } from './richieste-dgpe.service';

@Injectable({
  providedIn: 'root'
})
export class RichiesteDgpeDataSource implements DataSource<ModelEventiCalamitosi.RichiestaDgpeDTO> {

  private richiesteDgpeSubject = new BehaviorSubject<ModelEventiCalamitosi.RichiestaDgpeDTO[]>([]);
  private loadingSubject = new BehaviorSubject<boolean>(false);
  public loading$ = this.loadingSubject.asObservable();
  private errorSubject = new BehaviorSubject<boolean>(false);
  public errors$ = this.errorSubject.asObservable();
  isLoading: boolean = false;
  errorMessage: string = null;

  private countSubject = new BehaviorSubject<number>(0);
  public counter$ = this.countSubject.asObservable();

  constructor(private richiesteDgpeService : RichiesteDgpeService) {
  }

  loadOcdpc(ipa: string,
    filter: ModelEventiCalamitosi.RichiestaDgpeFilterDTO,
    sortDirection: string,
    pageIndex: number,
    pageSize: number,
    ) {

    this.loadingSubject.next(true);

    this.richiesteDgpeService.getOcdpc( pageIndex, pageSize,sortDirection, {
      ocdpc: filter.ocdpc,
      informazioniOcdpc:filter.informazioniOcdpc,
      commissario:filter.commissario,
      dataInizioDa: filter.dataInizioDa,
      dataInizioA: filter.dataInizioA,
      dataFineDa: filter.dataFineDa,
      dataFineA:filter.dataFineA
    }).pipe(
      catchError(err => {
      this.errorSubject.next(true);
      return throwError(err);
    }),
    catchError(err => {
      return of([]);
    }),
      finalize(() => this.loadingSubject.next(false))
    )
      .subscribe(result => {
        this.richiesteDgpeSubject.next(result['content']);
        this.countSubject.next(result['totalElements']);
      }
      );
  }

  connect(collectionViewer: CollectionViewer): Observable<ModelEventiCalamitosi.RichiestaDgpeDTO[]> {
    return this.richiesteDgpeSubject.asObservable();
  }

  disconnect(collectionViewer: CollectionViewer): void {
    this.richiesteDgpeSubject.complete();
    this.loadingSubject.complete();
  }

}

